import React from 'react';
import { number } from 'prop-types';
import { audioDurationToText } from '../utils';

const AudioLength = ({ currentPosition, totalLength }) => (
    <div className="audio-length">
        <span>{audioDurationToText(currentPosition)}</span> / <span>{audioDurationToText(totalLength)}</span>
    </div>
);

AudioLength.propTypes = {
    currentPosition: number,
    totalLength: number,
};

export default AudioLength;
